import React, { useEffect, useState } from "react";
import { Accordion, Button, Form, Row, Col } from 'react-bootstrap';
import { Link, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { getBodySymptomBurdenGraphV2 } from "store/services/clientDataReportsService";
import * as actions from "store/actions"
import CustomBarChart from "../CustomChart";
import DownloadBSBurdenGraph from "../PDFReportComponents/BodySymptomGraphPdf";

import { ReactComponent as DownloadIcn } from "Assets/Images/icn/download.svg";
import { LineChart } from "../LineChart";
import { getChartHeightByScreenSize, getScreenSize } from "components/shared/ChartConfig";

const BodySymptomGraph = ({ dispatch, eventKey, todoId, client, submittedOn }) => {
  const { clientId } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [bodySymptomBurdenGraphData, setBodySymptomBurdenGraphData] = useState(null);
  const [selectedChartType, setSelectedChartType] = useState("bar");
  const [chartHeight, setChartHeight] = useState(175);
  const [screenSize, setScreenSize] = useState("extra-large");

  const chartTitle = "Body Systems Symptom Burden Graph";

  useEffect(() => {
    let size = getScreenSize(screenSize);
    setScreenSize(size);
  }, []);

  useEffect(() => {
    let height = getChartHeightByScreenSize(screenSize, chartHeight);
    setChartHeight(height);
  }, [screenSize]);

  useEffect(() => {
    if (isOpen && !bodySymptomBurdenGraphData) {
      getBodySymptomBurdenGraphData();
    }
  }, [isOpen]);

  const getBodySymptomBurdenGraphData = async () => {
    try {
      if (!todoId) {
        throw new Error("Invalid ToDo ID");
      }
      let data = {
        todoId,
        clientId
      };
      setIsLoading(true);
      dispatch(actions.persist_store({ loader: true }));
      const response = await getBodySymptomBurdenGraphV2(data);
      if (response.success === true) {
        const data = response.body;
        setBodySymptomBurdenGraphData(data);
      }
      setIsLoading(false);
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      setIsLoading(false);
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  }

  

  return (
    <Accordion.Item eventKey={eventKey} className="priority-report my-2">
      <Accordion.Header
       className="accordian-cap "
      >
        Body Systems Symptom Burden Graph
        <span className="toggleBtn position-absolute"></span>
      </Accordion.Header>
      <Accordion.Body
        onEnter={() => {
          setIsOpen(true)
        }}
        onExit={() => {
          setIsOpen(false)
        }}
      >
        <div className="accordion-inner">
          <div className="py-2">
            <div className="top d-flex align-items-center justify-content-between gap-10">
              <div className="left">
                <Form.Label>
                  Chart type:
                </Form.Label>
                <Form.Select
                  onChange={(e) => {
                    setSelectedChartType(e.target.value);
                  }}
                  value={selectedChartType}
                >
                  <option value="bar">Bar Chart</option>
                  <option value="line">Line Chart</option>
                </Form.Select>
              </div>
              <div className="right">
              </div>
            </div>
          </div>
          {isLoading ?
            <p>Loading...</p>
            :
            bodySymptomBurdenGraphData ?
              <>
              {selectedChartType === "line" ? (
                <div className="mt-4">
                  <h6>{chartTitle}</h6>
                  <LineChart
                    chartData={bodySymptomBurdenGraphData}
                    height={chartHeight}
                    screenSize={screenSize}
                  />
                </div>
              ):(
                <CustomBarChart
                  dataset={bodySymptomBurdenGraphData}
                  title={chartTitle}
                  totalsTitle="Body Systems Totals"
                  defaultShowMaxes={true}
                />
              )}
              </>
              :
              <>
                <p>Data not found</p>
              </>
          }
        </div>
      </Accordion.Body>
    </Accordion.Item>
  )
}

const mapStateToPros = (state) => {
  return {
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(BodySymptomGraph);